import React from 'react';

import dayjs from 'dayjs';

import FreelacerFooter from 'pages/freelancer/FreelancerAvailableJobs/components/footer/FreelancerFooter';

import Heading from 'pages/freelancer/FreelancerAvailableJobs/components/heading/Heading';

import FreelancerNavBar from 'pages/freelancer/FreelancerAvailableJobs/components/navigationBar/FreelancerNavBar';

import Message from 'pages/freelancer/FreelancerAvailableJobs/components/message/message';

import { createLocale } from 'locales';

import Filters from './components/filters/Filters';

import PeriodJobList from './components/jobList/PeriodJobList';

const localize = createLocale('freelancerAvailableJobsLocales');

const FreelancerPeriodJobs: React.FC = () => {
  const title = 'Let op:';
  const text = `Sinds 1 Mei zijn de interessediensten komen te vervallen, op de wijze zoals u die kent. 
        Wij hebben deze aanpassing moeten doen ter voorkoming van schijnzelfstandigheid en om de inzetbaarheid van de pedagogisch medewerkers te vergroten. Hierbij hebben we een aantal dingen over het hoofd gezien die we de komende weken zullen aanpassen.
        We ontvangen reacties en vragen vanuit organisaties en freelancers. We inventariseren momenteel alle feedback en suggesties, want jullie input is voor ons belangrijk.
        Wil je een suggestie aandragen, dan ontvangen we die graag per e-mail. Deze mag je sturen naar: info@tadaah.nl met als onderwerp: werking platform.`;
  const delay = '2023-05-14';
  const today = dayjs().format('YYYY-MM-DD');
  const displayMessage = !!(today < delay);
  return (
    <>
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <div className="flex items-center flex-col justify-center w-full">
        <FreelancerNavBar />
        <Message
          title={title}
          text={text}
          visible={displayMessage}
          variant="warning"
        />
        <Heading
          leftBtnActive
          title={localize('longerAssignments')}
          containerClassName={displayMessage ? 'mt-0' : 'mt-16'}
        />
        <Filters />
        <PeriodJobList />
        <FreelacerFooter />
      </div>
    </>
  );
};

export default FreelancerPeriodJobs;
